import type { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MySironaPersonService } from './my-sirona-person.service';

@Injectable()
export class MySironaPersonGuard implements CanActivate {

    constructor(
        private readonly mySironaPersonService: MySironaPersonService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const id = parseInt(route.params.id, 10);

        if (isNaN(id) || id <= 0) {
            console.error(`Route parameter '${route.params.id}' isn't a valid id!`);
            return of(false);
        }

        this.mySironaPersonService.setPersonId(id);
        return of(true);
    }
}
